/* Video Looping (KAN-127) — section-scoped script.
   Loaded on demand by sections/video-looping.liquid (asset_url).
   Not part of the global skb-custom.js. */
if (!window.__vloopLoaded) {
  window.__vloopLoaded = true;
  // === Video Looping — centered-focus carousel + shop-the-look pop-up (KAN-127) ===
  // Self-contained. No theme components used. Mirrors the Eurus "Video looping"
  // section: the card nearest the centre is "focused" (enlarged, full colour, its
  // video playing); others slide to the sides and (optionally) desaturate.
  (function () {
    function inViewport(el) {
      var r = el.getBoundingClientRect();
      var h = window.innerHeight || document.documentElement.clientHeight;
      return r.bottom > 0 && r.top < h;
    }

    // Only the focused (centred) video plays; every other video is paused so it
    // stays on its poster frame. Called from updateFocus on load / scroll / resize.
    function updatePlayback(section) {
      cardsOf(section).forEach(function (card) {
        var v = card.querySelector('video');
        if (!v) return;
        if (card.classList.contains('is-focused') && inViewport(card)) {
          v.muted = true;
          var p = v.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }

    function cardsOf(section) {
      return Array.prototype.slice.call(section.querySelectorAll('.vloop__card'));
    }

    function isHorizontal(track) {
      return track.scrollWidth > track.clientWidth + 4;
    }

    function ensureEmbed(card) {
      var box = card && card.querySelector('.vloop__embed');
      if (!box || box.dataset.loaded === 'true') return;
      var type = box.dataset.embedType;
      var id = box.dataset.embedId;
      if (!id) return;
      var src;
      if (type === 'youtube') {
        src =
          'https://www.youtube.com/embed/' +
          id +
          '?autoplay=1&mute=1&loop=1&playlist=' +
          id +
          '&controls=0&playsinline=1&rel=0&modestbranding=1';
      } else if (type === 'vimeo') {
        src = 'https://player.vimeo.com/video/' + id + '?autoplay=1&muted=1&loop=1&background=1';
      } else {
        return;
      }
      var frame = document.createElement('iframe');
      frame.src = src;
      frame.allow = 'autoplay; encrypted-media; picture-in-picture';
      frame.setAttribute('allowfullscreen', '');
      frame.setAttribute('tabindex', '-1');
      box.appendChild(frame);
      box.dataset.loaded = 'true';
    }

    // On desktop the card width is derived from the section height, so publish
    // the real (unscaled) card width for the track's centering padding.
    function measureCards(section) {
      var track = section.querySelector('.vloop__track');
      var card = section.querySelector('.vloop__card:not(.vloop__card--clone)');
      if (!track || !card) return;
      var w = card.offsetWidth;
      if (w) track.style.setProperty('--vloop-card-w', w + 'px');
    }

    function updateFocus(section) {
      var track = section.querySelector('.vloop__track');
      if (!track) return;
      var cards = cardsOf(section);
      if (!cards.length) return;

      measureCards(section);

      var horizontal = isHorizontal(track);
      var ref;
      if (horizontal) {
        var tr = track.getBoundingClientRect();
        ref = tr.left + tr.width / 2;
      } else {
        ref = window.innerHeight / 2;
      }

      var best = 0;
      var bestDist = Infinity;
      cards.forEach(function (card, i) {
        if (card.offsetParent === null) return; // skip hidden clones (stacked mobile)
        var r = card.getBoundingClientRect();
        var center = horizontal ? r.left + r.width / 2 : r.top + r.height / 2;
        var dist = Math.abs(center - ref);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });

      cards.forEach(function (card, i) {
        card.classList.toggle('is-focused', i === best);
      });
      ensureEmbed(cards[best]);
      section._vloopFocus = best;

      var focused = cards[best];
      var realIndex = focused && focused.dataset.realIndex != null ? Number(focused.dataset.realIndex) : best;
      section._vloopReal = realIndex;

      // Pagination dots (mapped to the real video index; clones share the index)
      section.querySelectorAll('[data-vloop-dot]').forEach(function (dot) {
        if (Number(dot.getAttribute('data-vloop-dot')) === realIndex) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      updatePlayback(section);
    }

    function centerElement(track, el, smooth) {
      if (!track || !el) return;
      if (isHorizontal(track)) {
        var tr = track.getBoundingClientRect();
        var cr = el.getBoundingClientRect();
        var delta = cr.left + cr.width / 2 - (tr.left + tr.width / 2);
        if (smooth) {
          track.scrollBy({ left: delta, behavior: 'smooth' });
        } else {
          // Force an instant jump: the CSS `scroll-behavior: smooth` on the track
          // would otherwise animate this scrollLeft change, making the seamless
          // loop reposition visibly slide back. Disable it for this one write.
          var prevBehavior = track.style.scrollBehavior;
          track.style.scrollBehavior = 'auto';
          track.scrollLeft += delta;
          track.style.scrollBehavior = prevBehavior;
        }
      } else if (smooth) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    function centerCard(section, index, smooth) {
      var track = section.querySelector('.vloop__track');
      var cards = cardsOf(section);
      if (!track || !cards.length) return;
      index = Math.max(0, Math.min(cards.length - 1, index));
      centerElement(track, cards[index], smooth);
    }

    function goTo(section, index) {
      centerCard(section, index, true);
    }

    function realCards(section) {
      return Array.prototype.slice.call(section.querySelectorAll('.vloop__card:not(.vloop__card--clone)'));
    }

    // Infinite loop: clone the full set of videos on both sides so there is
    // always a neighbour to scroll to. When the centred card lands in a clone
    // zone we jump (instantly, seamlessly) to the identical real card.
    function setupLoop(section) {
      var track = section.querySelector('.vloop__track');
      if (!track || track._vloopLooped) return;
      var reals = realCards(section);
      if (reals.length < 2) return;
      track._vloopLooped = true;
      reals.forEach(function (card, i) {
        card.dataset.realIndex = i;
      });
      function clone(card) {
        var c = card.cloneNode(true);
        c.classList.add('vloop__card--clone');
        c.setAttribute('aria-hidden', 'true');
        // Drop duplicated quick-buy modals (unique ids); the clone's "+" button
        // keeps aria-controls pointing at the original modal id.
        c.querySelectorAll('quick-buy-modal').forEach(function (m) {
          m.remove();
        });
        return c;
      }
      var lead = document.createDocumentFragment();
      var trail = document.createDocumentFragment();
      reals.forEach(function (card) {
        lead.appendChild(clone(card));
      });
      reals.forEach(function (card) {
        trail.appendChild(clone(card));
      });
      track.insertBefore(lead, reals[0]);
      track.appendChild(trail);
    }

    function reposition(section) {
      var track = section.querySelector('.vloop__track');
      if (!track || !track._vloopLooped || !isHorizontal(track)) return;
      var cards = cardsOf(section);
      var card = cards[section._vloopFocus || 0];
      if (!card || !card.classList.contains('vloop__card--clone')) return;
      var realIndex = Number(card.dataset.realIndex);
      var target = track.querySelector('.vloop__card:not(.vloop__card--clone)[data-real-index="' + realIndex + '"]');
      if (target) {
        centerElement(track, target, false);
        updateFocus(section);
      }
    }

    function initSection(section) {
      if (section._vloopInit) return;
      section._vloopInit = true;

      var track = section.querySelector('.vloop__track');
      if (!track) return;

      setupLoop(section);

      section.querySelectorAll('video').forEach(function (video) {
        video.muted = true;
      });

      var raf = null;
      function onScroll() {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          updateFocus(section);
        });
      }
      track.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);

      // Seamless loop: after scrolling settles on a clone, jump to the real card.
      var settleTimer = null;
      track.addEventListener(
        'scroll',
        function () {
          if (settleTimer) clearTimeout(settleTimer);
          settleTimer = setTimeout(function () {
            reposition(section);
          }, 140);
        },
        { passive: true }
      );

      var prev = section.querySelector('.vloop__arrow--prev');
      var next = section.querySelector('.vloop__arrow--next');
      if (prev)
        prev.addEventListener('click', function () {
          goTo(section, (section._vloopFocus || 0) - 1);
        });
      if (next)
        next.addEventListener('click', function () {
          goTo(section, (section._vloopFocus || 0) + 1);
        });

      section.querySelectorAll('[data-vloop-dot]').forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(section, Number(dot.getAttribute('data-vloop-dot')));
        });
      });

      // Auto-advance
      if (section.dataset.autoplaySlide === 'true') {
        var speed = (parseInt(section.dataset.autoplaySpeed, 10) || 5) * 1000;
        var viewport = section.querySelector('.vloop__viewport');
        section._vloopPaused = false;
        if (viewport) {
          viewport.addEventListener('pointerenter', function () {
            section._vloopPaused = true;
          });
          viewport.addEventListener('pointerleave', function () {
            section._vloopPaused = false;
          });
        }
        setInterval(function () {
          if (section._vloopPaused) return;
          if (section.querySelector('dialog[open]')) return;
          var cards = cardsOf(section);
          if (cards.length < 2) return;
          var nextIndex = ((section._vloopFocus || 0) + 1) % cards.length;
          goTo(section, nextIndex);
        }, speed);
      }

      // Centre the configured video on load (1-based setting; defaults to the middle).
      var reals = realCards(section);
      var rcount = reals.length || cardsOf(section).length;
      var initial = parseInt(section.dataset.initialIndex, 10);
      if (isNaN(initial) || initial < 1) initial = Math.ceil(rcount / 2);
      initial = Math.max(1, Math.min(rcount, initial)) - 1;
      requestAnimationFrame(function () {
        measureCards(section);
        var target = realCards(section)[initial];
        if (target) centerElement(track, target, false);
        else centerCard(section, initial, false);
        updateFocus(section);
      });
    }

    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('[data-vloop]').forEach(initSection);
    }

    // Add-to-cart ("+") and quick-buy ("choose options") are handled by the
    // theme's own <product-form> / <quick-buy-modal> custom elements.

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();
}
